import { ICONS } from 'assets/icons';
import SettingsIcon from "../../../assets/customSVG/channels/SettingsIcon";
import { KeyOutlined, ApiOutlined } from '@ant-design/icons';
import WhatsAppIcon from '../../../assets/customSVG/Whatsapp';

export const settingsMenu = [
  {
    id: 1,
    name: 'Keywords',
    label: 'keywords',
    icon: SettingsIcon,
    iconType: 'custom',
    link: '/user/settings/keywords',
  },
  {
    id: 2,
    icon: KeyOutlined,
    iconType: 'antd',
    name: 'API Keys',
    label: 'api-keys',
    link: '/user/settings/api-keys',
  },
  {
    id: 3,
    name: 'WhatsApp Widget',
    label: 'whatsapp-widget',
    icon: WhatsAppIcon,
    iconType: 'custom',
    link: '/user/settings/whatsapp-widget',
  },
  {
    id: 4,
    icon: ApiOutlined,
    iconType: 'antd',
    name: 'API Campaigns',
    label: 'api-campaigns',
    link: '/user/settings/api-campaigns',
  },
];
